import * as i18ncountry from 'i18n-iso-countries'
import { useMemo } from 'react'
import { SupportedLocale } from '@rw1/localization'
import { TOption } from './types'

export const useCountriesList = (
  language: SupportedLocale,
): TOption[] => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18ncountry.registerLocale(require('i18n-iso-countries/langs/de.json'))
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18ncountry.registerLocale(require('i18n-iso-countries/langs/en.json'))
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18ncountry.registerLocale(require('i18n-iso-countries/langs/zh.json'))
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18ncountry.registerLocale(require('i18n-iso-countries/langs/es.json'))
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18ncountry.registerLocale(require('i18n-iso-countries/langs/ja.json'))
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  i18ncountry.registerLocale(require('i18n-iso-countries/langs/fr.json'))

  return useMemo(() => {
    const countries = i18ncountry.getNames(language)

    return Object.keys(countries)
      .map((key) => ({
        id: `${key}`,
        label: `${countries[key]}`,
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }, [language])
}
